<div class="nav-bar">

    <div class="logo-container" [routerLink]="'/' + getCountry() + '/'">
      <img alt="" class="cc-logo" src="./assets/images/cc_logo.png">
      <span class="cc-text">{{getString('cheapcharts')}}</span>
    </div>

    <div class="nav-container">
      <app-navigation class="app-nav-component"></app-navigation>
    </div>

    <div class="apps-container">
      <div class="download-app-container">
        <a href="https://play.google.com/store/apps/details?id=com.lollipapp.cc" target="_blank">
          <img alt="" class="download-app-button" [src]="getGooglePlayImageUrl()">
        </a>
      </div>
      <div class="download-app-container">
        <a href="https://itunes.apple.com/app/cheapcharts-itunes-deals-for-movies-tv-apps/id772046134?mt=8"
        target="_blank"><img alt="" class="download-app-button" [src]="getAppStoreImageUrl()"></a>
      </div>
    </div>

</div>

<div class="mobile-nav-bar">
  <div class="hamburger-container">
    <img alt="" class="burger-icon" src="./assets/images/three_dots.png" (click)="burgerClicked()">
  </div>
  <div class="logo-container" [routerLink]="'/' + getCountry() + '/'">
    <img alt="" class="cc-logo" src="./assets/images/cc_logo.png">
    <span class="cc-text">{{getString('cheapcharts')}}</span>
  </div>
  <a class="mobile-search-link" [routerLink]="'/' + getCountry() + '/' + getString('searchUrl')" rel="nofollow">{{getString('search')}}</a>
  <div class="mobile-search-bar">
    <app-nav-search-bar class="nav-search-bar-component" (onSearchClicked)="searchClicked($event)"></app-nav-search-bar>
  </div>
</div>
